import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { Modal } from "@Core/components/Layouts";
import { Button } from "@Core/components/UI";
import { useMatomo } from "@Core/hooks";
import { MatomoCategory } from "@Core/interfaces";
import { useCoreStores } from "@Core/stores";

import { usePNIStores } from "@PNI/stores";

import { FilePageHeaderCloseOmissionModalProps } from "./FilePageHeaderCloseOmissionModal.props";

export const FilePageHeaderCloseOmissionModal = ({ isVisible, toggle }: FilePageHeaderCloseOmissionModalProps) => {
  const { t } = useTranslation();
  const { UserStore } = useCoreStores();
  const { FileStore } = usePNIStores();
  const trackEvent = useMatomo();

  const handleSubmit = async () => {
    try {
      await FileStore.file?.closeAbsence();
      await Promise.all([UserStore.load(), FileStore.load()]);

      trackEvent(MatomoCategory.File, t("FILES.MODALS.CLOSE_OMISSION.SUCCESS"));

      toast.success(t("FILES.MODALS.CLOSE_OMISSION.SUCCESS"));
    } catch (e) {
      toast.error(t("FILES.MODALS.CLOSE_OMISSION.ERROR"));
    } finally {
      toggle();
    }
  };

  return (
    <Modal
      title={t("FILES.MODALS.CLOSE_OMISSION.POPUP_TITLE")}
      isVisible={isVisible}
      hide={toggle}
      data-matomo-category={MatomoCategory.File}
    >
      <p>{t("FILES.MODALS.CLOSE_OMISSION.POPUP_TEXT")}</p>

      <Button primary onClick={handleSubmit}>
        {t("FILES.MODALS.CLOSE_OMISSION.POPUP_BUTTON")}
      </Button>
    </Modal>
  );
};
